const initialState = {
  rtpDetails: [],
  returnToProvisionLoading: false,
  uploadResponse: null,
};

export default initialState;
